export default {"src":"/_next/static/media/copyAddressIcon.19855eb3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};